import { ControlledTextField } from '@act/storybook';
import { Control } from 'react-hook-form';
import type { SurveyFormData } from './types';

export interface TextInputProps {
  control: Control<SurveyFormData>;
  name: string;
  isRequired: boolean;
  isMultiline?: boolean;
}

const TextInput = ({
  control,
  name,
  isRequired,
  isMultiline = false,
}: TextInputProps) => {
  const rows = isMultiline ? 4 : 1;
  return (
    <ControlledTextField<SurveyFormData, typeof name>
      trackingName="survey-text-input"
      maxRows={rows}
      name={name}
      label={''}
      control={control}
      required={isRequired}
      multiline={isMultiline}
      minRows={rows}
    />
  );
};

export default TextInput;
